// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1zTDX","loaderOuter":"PageOverlayLoader_loaderOuter__3yEOH"};